/* Etiquetas multiidoma en castellano. */
export default {
  "qrScanner.lanternButton": "Lantern",
  "qrScanner.closeButton": "Close",
};
